export enum Roles {
  ONBOARDING = 'ONBOARDING',
}

export enum Routes {
  AGENCY_REGISTRATION = '/save/app/client/ui/agencies/registration',
}
